import { Text } from '@react-pdf/renderer';

interface FooterProps {
    footerText: string;
}

const Footer = ({ footerText }: FooterProps) => (
    <Text
        fixed
        style={{
            position: 'absolute',
            fontSize: 10,
            bottom: 20,
            left: 40,
            right: 40,
            textAlign: 'center',
        }}
    >
        {footerText}
    </Text>
);

export default Footer;